import { Box, Text, useMediaQuery } from "@chakra-ui/react"

import { useAppSelector } from "app/hooks"
import MobileSideMenu from "components/sidemenu/mobilesidemenu"
import { selectListingsPageMenuItems } from "store/ui/uiSlice"

const TemplateHeader = ({
  text,
  color = "black",
  fontSize = {
    base: "20px",
    md: "28px",
  },
}: {
  text: string
  color?: string
  fontSize?: { base: string; md: string }
}) => {
  const [isMobile] = useMediaQuery("(max-width: 1024px)")
  const listingPageMenuItems = useAppSelector(selectListingsPageMenuItems)
  return (
    <Box
      mb={{ base: "0px", lg2: "12px" }}
      display='flex'
      justifyContent='space-between'
      alignItems='center'
      gap='16px'
    >
      {/* title and create button */}
      <Text
        fontSize={fontSize}
        fontWeight={{
          base: 600,
          md: 700,
        }}
        color={color}
        lineHeight='31px'
      >
        {text}
      </Text>
      {isMobile && <MobileSideMenu sidebarMenuArr={listingPageMenuItems} />}
    </Box>
  )
}
export default TemplateHeader
